
export const customStyles = {
    table: {
        style: {
            boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px"
        },
    },
    rows: {
        style: {
            borderBottom: "1px solid #bdc3c7",
            padding: "10px",
            overflow:"visible"
        },
    },
    headRow: {
        style: {
            fontSize: "15px",
            textAlign: 'center'
            // display: "none", // Hides headers
        },
    },
};
